import React from "react";
import "./PlayIcon.css";
import "../../index.css";

const PlayIcon = ({
  children,
  onClick,
  mediaWrap,
  width,
  visible = true,
  bg = "bg-dark",
  boxShadow = null,
  playOverlay = false
}) => {
  return (
            <span className="button-cover__play-icon"><i className="fa-solid fa-play"></i></span>
  );
};

export default PlayIcon;